import React from "react";
import Health_Insurance_Card from "../../containers/Health_Insurance_Card/Index";

export default function Health_Insurance_Card_Component() {
  return (
    <div>
      <Health_Insurance_Card />
    </div>
  );
}
